import React,{Component} from 'react';
import { change } from 'redux-form';
import { batchActions } from 'redux-batched-actions';
import routes from '../routeconfig';

//import DetailForm from '../containers/details';

export function updateAppState (prop, value) {
	return {
		type: 'GS_App_Update',
		payload: {prop, value}
	}
};

export function updateComponentState (title, value) {
	return {
		type: 'GS_ComponentState_Update',
		payload: {title, value}
	}
};


// WEBPACK FOOTER //
// ./public/react/actions/actions.js